import { Fragment } from 'react'

import {
  Box,
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import androidImg from 'src/assets/image/crud-voice-permission-help-android.jpg'
import chromeImg from 'src/assets/image/crud-voice-permission-help-chrome.jpg'
import iosImg from 'src/assets/image/crud-voice-permission-help-iOS.jpg'
import safariImg from 'src/assets/image/crud-voice-permission-help-safari.jpg'
import BrandButton from 'src/components/widgets/buttons/BrandButton'
import { BrandColor } from 'src/types'

import ItListImage from '../../ItListImage/ItListImage'

const systemMicrophoneHelp = [
  {
    image: iosImg,
    system: 'iOS',
    description:
      "Click on the 'Aa' icon by the URL bar, then to Website Settings > Microphone to enable.",
  },
  {
    image: chromeImg,
    system: 'Chrome',
    description:
      "Click on the 'Lock' icon left of the URL bar and go to Site Settings to enable the microphone.",
  },
  {
    image: androidImg,
    system: 'Android',
    description:
      "Click on the '•••' icon by the URL bar and go to Site Settings to enable mic access.",
  },
  {
    image: safariImg,
    system: 'Safari',
    description:
      'Go to Safari > Settings for this site... > Microphone to enable your mic.',
  },
]

const renderMicrophoneHelp = (
  image: string,
  system: string,
  description: string
) => {
  return (
    <Flex py={4} gap={4} alignItems="center">
      <ItListImage
        htmlHeight={64}
        htmlWidth={64}
        w="64px"
        borderRadius={8}
        objectFit="cover"
        src={image}
        alt={`instruction illustration for ${system}`}
      />
      <Flex direction="column">
        <Text className="body-regular-emphasis">{system}</Text>
        <Text className="body-extra-small">{description}</Text>
      </Flex>
    </Flex>
  )
}

type MicrophoneInstructionModalProps = {
  brandColor: BrandColor
  modalOpen: boolean
  setModalOpen: (isOpen: boolean) => void
}

const MicrophoneInstructionModal = (props: MicrophoneInstructionModalProps) => {
  return (
    <Modal
      isOpen={props.modalOpen}
      onClose={() => props.setModalOpen(false)}
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        borderRadius="16px"
        width={{ base: '343px', md: '400px', lg: '450px' }}
      >
        <ModalHeader p={0}>
          <Text as="h5" className="thick" align="center" my={4}>
            Unable to access microphone
          </Text>
          <Divider />
        </ModalHeader>
        <ModalBody px={4}>
          <Flex direction="column">
            {systemMicrophoneHelp.map((item, index) => {
              return (
                <Fragment key={item.system}>
                  {renderMicrophoneHelp(
                    item.image,
                    item.system,
                    item.description
                  )}
                  {index != systemMicrophoneHelp.length - 1 && <Divider />}
                </Fragment>
              )
            })}
          </Flex>
        </ModalBody>

        <ModalFooter
          p={0}
          flexDirection="column"
          justifyContent="space-between"
        >
          <Divider />
          <Box p={4} w="100%">
            <BrandButton
              brandColor={props.brandColor}
              w="100%"
              onClick={() => props.setModalOpen(false)}
            >
              Got it!
            </BrandButton>
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default MicrophoneInstructionModal
